import { useState, useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faCircle,
	faChevronCircleRight,
} from "@fortawesome/pro-light-svg-icons";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons";

import { API_URL_DONATE } from "../../utils/helpers";

import Alert from "../../components/Alert";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

import PaymentTable from "./PaymentTable";
import PaymentClover from "./PaymentClover";

export default function Payment({ cares, id, handleStatus }) {
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});
	const [, setDetails] = useState({});
	const [payment, setPayment] = useState({});
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});

	const formElement = useRef();

	const initRef = useRef(false);

	useEffect(() => {
		if (initRef.current) return;
		initRef.current = true;

		init();
	});

	const init = async () => {
		const url = new URL(`${API_URL_DONATE}/`);
		const params = {
			f: `ccPaymentInit`,
			id,
			x: uuidv4(),
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url.href, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setDetails({ ...json.details });
				setPayment({ ...json.payment });
				setAlert({});
			} else {
				handleStatus("", 4);
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL_DONATE}/?f=ccPayment`);

		let formData = new FormData();
		// Object.entries(names).forEach(([key, value]) => data.append(key, value));
		formData.append("method", names.method ? names.method : "");
		formData.append("id", id);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({});
				handleStatus(json.id, 1);
			} else {
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<form
						method="post"
						action="/"
						onSubmit={(e) => handleSubmit(e)}
						ref={formElement}
						id="coutoureclub"
					>
						<h3>Select Payment Method</h3>

						<div className="buttons-container">
							{[
								{
									id: "card",
									name: "Credit or Debit Card",
								},
								{
									id: "check",
									name: "Mail a Check",
								},
							].map((item) => {
								return (
									<button
										type="button"
										onClick={() => handleUpdate("method", item.id)}
										key={item.id}
									>
										<div>
											<FontAwesomeIcon
												icon={
													names.method === item.id ? faCircleCheck : faCircle
												}
												size="lg"
											/>
											<span>{item.name}</span>
										</div>
									</button>
								);
							})}
						</div>

						<p
							className="line"
							style={{ marginTop: "0", marginBottom: "15px" }}
						/>
						<h3>Order Summary</h3>

						<PaymentTable
							data={{ ...payment, method: names.method ? names.method : "" }}
							handleClick={() => handleStatus(id, 4)}
						/>

						{names.method === "check" && (
							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" ? "hidden" : "submit-container"
									}
								>
									<Submit
										name="Submit Registration"
										icon={faChevronCircleRight}
										cares={cares}
									/>
								</div>
							</div>
						)}
					</form>

					{names.method === "card" && (
						<PaymentClover cares={cares} id={id} handleStatus={handleStatus} />
					)}
				</>
			)}
		</>
	);
}
